import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

type HeartIconProps = IconClientSVGProps & {
  filled?: boolean;
};

export const HeartIcon = forwardRef<SVGSVGElement, HeartIconProps>(
  ({ filled, label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg viewBox="0 0 18 16" ref={ref} {...props}>
          <path
            d="M2.12262 2.48036C5.58094 -1.02518 8.99975 3.51987 8.99975 3.51987C8.99975 3.51987 12.4974 -1.37562 15.9556 2.48035C20.4468 7.48813 8.99975 15 8.99975 15C8.99975 15 -2.57722 7.24437 2.12262 2.48036Z"
            fill={filled ? "currentColor" : "none"}
            stroke="currentColor"
          />
        </svg>
      </Icon>
    );
  },
);

HeartIcon.displayName = "HeartIcon";
